import React from 'react';
import PropTypes from 'prop-types';

var SvgContextMixin = require('./svgContextMixin');

var ALIGN_LEFT = "leftAlign",
  ALIGN_RIGHT = "rightAlign";
var MAX_FONT_SIZE = 8;

var SvgChartLinkedLegend = React.createClass({
  mixins: [SvgContextMixin],

  statics: {
    id: "ChartLinkedLegend",
    legendItemId: "ChartLinkedLegendItem",
    barColor: "#C2C2C2",
    textColor: "#FFFFFF",
    ALIGN_LEFT: ALIGN_LEFT,
    ALIGN_CENTER: ALIGN_RIGHT,
    itemBarWidthRate: 0.9,

    //TODO: move component's calculations to separate module
    getLegendPathLabelPoint(itemIndex, itemsCount, itemHeight, legendViewBox, chartWidth) {
      var legendHeight = legendViewBox[3];
      var legendWidth = legendViewBox[2];

      var legendItemHeight = legendHeight/itemsCount > itemHeight ? itemHeight : legendHeight/itemsCount;
      var y = legendViewBox[1] + (itemIndex + 0.5) * legendItemHeight;

      var itemWidth = SvgChartLinkedLegend.itemBarWidthRate * legendWidth;
      var x = legendViewBox[0] + chartWidth + (1 - SvgChartLinkedLegend.itemBarWidthRate)/2 * legendWidth;

      return {x: x, y: y};
    },
  },

  propTypes: {
    data: PropTypes.array.isRequired,
    itemHeight: PropTypes.number,
    onLegendItemClick: PropTypes.func,
    legendAlignment: PropTypes.string
  },

  getDefaultProps(){
    return {
      legendAlignment: ALIGN_RIGHT
    };
  },

  render(){
    return (
      <g id={SvgChartLinkedLegend.id}>
        {this._getLegendItems()}
      </g>
    );
  },

  _getLegendItems(){
    var {data, itemHeight, box, legendAlignment, columnCount, fontSize} = this.props;
    var countItems = data.length,
      x0 = this.context.relativeX(box[0]),
      y0 = this.context.relativeY(box[1]),
      width = this.context.relativeX(box[2]),
      height = this.context.relativeY(box[3]),
      itemRelatedWidth = width,
      rows = countItems,
      itemRelatedHeight = (height / rows) > this.context.relativeY(itemHeight)
        ? this.context.relativeY(itemHeight)
        : (height / rows),
      xPadding = 0;//(width - cols * itemRelatedWidth) / (cols + 1);

    var items = [];

    fontSize = fontSize || this.context.getFontSize(0.75 * itemRelatedHeight);
    fontSize = Math.min(fontSize,  MAX_FONT_SIZE);
    for (var i = 0; i < countItems; i++) {
      var rowNumber = i + 1;
      var colNumber = 1,
        dx = x0,
        dy = (rowNumber - 1) * itemRelatedHeight + y0;

      var rectColor = data[i].color,
        textDecoration = data[i].disabled
          ? "line-through" : "none";

      var coloredBoxFraction = 0.8;

      items.push(
        <g key={i} className="legend-item"
           onClick={this.props.onLegendItemClick.bind(null, data[i].id)}>
          <rect
            x={(1 - SvgChartLinkedLegend.itemBarWidthRate)/2 * itemRelatedWidth + dx}
            y={1/10 * itemRelatedHeight + dy}
            width={SvgChartLinkedLegend.itemBarWidthRate * itemRelatedWidth}
            height={8/10 * itemRelatedHeight}
            fill={rectColor}
          />
          {this._getItemText(data[i].title, 0.075 * itemRelatedWidth + dx, 0.5 * itemRelatedHeight + dy, fontSize, textDecoration, SvgChartLinkedLegend.textColor)}
        </g>
      )
    }

    return items;
  },

  _getItemText(text, x, y, fontSize, textDecoration, textColor){
    return (<text x={x} y={y} textAnchor="start"
                  dy="0.35em"
                  fontFamily={this.context.font} fontSize={fontSize}
                  textDecoration={textDecoration} fill={textColor}>
      {text}
    </text>);
  }
});


module.exports = SvgChartLinkedLegend;
